import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const useValidateUrl = () => {
  const [error, setError] = useState('')
  const { t } = useTranslation()

  const validateUrl = url => {
    if (url.length > 200) {
      setError(t('Máximo 200 caracteres'))
    } else if (!/^(ftp|http|https):\/\/[^ "]+$/.test(url)) {
      setError(t('La URL no es válida'))
    } else {
      setError('')
    }
  }

  return { error, validateUrl }
}

export default useValidateUrl
